import api from './api';

const R = (id) => `/api/interview-room/${id}`;
const C = (t) => `/api/room/c/${t}`;

export const roomAPI = {
  get: (id) => api.get(R(id)),
  join: (id) => api.post(`${R(id)}/join`),
  copilot: (id, after = 0) => api.get(`${R(id)}/copilot`, { params: { after } }),
  suggest: (id) => api.post(`${R(id)}/copilot/suggest`),
  markSuggestion: (id, sid, status) => api.post(`${R(id)}/copilot/suggestions/${sid}`, { status }),
  scorecards: (id) => api.get(`${R(id)}/scorecards`),
  saveScorecard: (id, data) => api.put(`${R(id)}/scorecard`, data),
  audio: (id, blob, role, startedAt) => {
    const fd = new FormData();
    const ext = (blob.type || '').includes('mp4') ? 'mp4' : 'webm';
    fd.append('file', blob, `chunk.${ext}`);
    fd.append('role', role);
    fd.append('started_at_ms', String(Math.round(startedAt || 0)));
    return api.post(`${R(id)}/audio`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const candidateRoomAPI = {
  context: (t) => api.get(C(t)),
  join: (t, transcription) => api.post(`${C(t)}/join`, { transcription }),
  staffPath: (t) => api.get(`${C(t)}/staff`),
};

export const RECS = [
  ['strong_no', 'Strong no', 'red'],
  ['no', 'No', 'amber'],
  ['yes', 'Yes', 'teal'],
  ['strong_yes', 'Strong yes', 'green'],
];

export const VERDICT_TONE = { 'Strong hire': 'green', Hire: 'teal', 'Mixed: discuss': 'amber', 'No hire': 'red', 'Strong no hire': 'red' };

export const KIND_LABEL = { follow_up: 'Follow-up', gap: 'Evidence gap', verify_claim: 'Verify claim' };

export const COVERAGE_TONE = { not_yet: 'slate', partial: 'amber', covered: 'green' };
